import { tagGroupService } from '../_services';

const getDefaultState = () => {
  return {
    loading: false,
    all: {},
    current: {},
    selectList: {}
  }
}

export const taggroups = {
  namespaced: true,
  state: getDefaultState(),
  actions: {
    resetState ({ commit }) {
      commit('resetState')
    },
    getAllTagGroups({ commit }) {
      commit('getAllTagGroupsRequest');
      tagGroupService.getAll()
      .then(
          tagGroups => commit('getAllTagGroupsSuccess', tagGroups),
          error => commit('getAllTagGroupsFailure', error)
      );
    },
    getSelectList({ commit }) {
      commit('getSelectListRequest');
      tagGroupService.getSelectList()
      .then(
          tagGroups => commit('getSelectListSuccess', tagGroups),
          error => commit('getSelectListFailure', error)
      );
    },
    getById({ commit }, id) {
      commit('getByIdRequest');
      tagGroupService.getById(id)
      .then(
        response => {
          commit('getByIdSuccess', response);
          return response;
        },
          error => {
            commit('getByIdFailure', error)
          return error;
          }
      );
    },
    addTagGroup({ commit }, payload){
      commit('addTagGroupRequest');
      tagGroupService.addTagGroup(payload)
      .then(
        tagGroups => commit('addTagGroupSuccess', tagGroups),
        error => commit('addTagGroupFailure', error)
      )
    },
    updateTagGroup({ commit }, payload){
      commit('updateTagGroupRequest');
      tagGroupService.updateTagGroup(payload)
      .then(
        tagGroups => commit('updateTagGroupSuccess', tagGroups),
        error => commit('updateTagGroupFailure', error)

      )
    },
    deleteTagGroup({ commit }, payload){
      commit('deleteTagGroupRequest');
      tagGroupService.deleteTagGroup(payload)
      .then(
        commit('deleteTagGroupSuccess'),
        error => commit('deleteTagGroupFailure', error)
      )
      return true;
    }
  },
  mutations: {
    resetState (state) {
      Object.assign(state, getDefaultState())
    },
    getAllTagGroupsRequest(state) {
        state.loading = true;
    },
    getAllTagGroupsSuccess(state, tagGroups) {
        state.loading = false;
        state.all = Object.values(tagGroups);
    },
    getAllTagGroupsFailure(state, error) {
        state.loading = false;
    },
    getSelectListRequest(state) {
        state.selectList = { loading: true };
    },
    getSelectListSuccess(state, tagGroups) {
        state.selectList = Object.values(tagGroups);
    },
    getSelectListFailure(state, error) {
        state.selectList = { error };
    },
    getByIdRequest(state) {
        state.current = { loading: true };
    },
    getByIdSuccess(state, tagGroup) {
      state.current = tagGroup;
      return tagGroup;
    },
    getByIdFailure(state, error) {
        state.current = { error };
    },
    addTagGroupRequest(state, tagGroup) {
      state.current = tagGroup
    },
    addTagGroupSuccess(state, tagGroup) {
      if(tagGroup.id == state.current.tagGroup.id){
        state.current = tagGroup;
      }
    },
    addTagGroupFailure(state, error) {
      state.update = { error };
    },
    updateTagGroupRequest(state, tagGroup) {
      state.current = tagGroup;
    },
    updateTagGroupSuccess(state, tagGroup) {
      if(tagGroup.id == state.current.tagGroup.id){
        state.current = tagGroup;
      }
    },
    updateTagGroupFailure(state, error) {
      state.update = { error };
    },
    deleteTagGroupRequest(state, tagGroup) {
      state.current = tagGroup
    },
    deleteUnitSuccess(state) {
        state.current = {};
        return true;
    },
    deleteUnitFailure(state, error) {
      state.update = { error };
    }
  }
}